import React from "react";

import { useTheme } from "@emotion/react";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";

export default function CustomSpeedDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [hidden] = React.useState(false);
  const theme = useTheme();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <SpeedDial
      ariaLabel="Ações"
      sx={{
        position: "fixed",
        bottom: theme.spacing(4),
        right: theme.spacing(10),
      }}
      hidden={hidden}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {props.children}
    </SpeedDial>
  );
}
